import { PrimaryEditorRenderEngine } from "../logic/render/PrimaryEditorRenderEngine";
import { BaseRenderEngine } from "../logic/render/BaseRenderEngine";
import { IRect } from "../interfaces/IRect";
import { IPoint } from "../interfaces/IPoint";
import { ISize } from "../interfaces/ISize";
import Scrollbars from "react-custom-scrollbars";
import { ViewPortHelper } from "../logic/helpers/ViewPortHelper";
import { LabelType } from "../data/enums/LabelType";

export class EditorModel {
  public static editor: HTMLDivElement;
  public static canvas: HTMLCanvasElement;
  public static mousePositionIndicator: HTMLDivElement;
  public static cursor: HTMLDivElement;
  public static viewPortScrollbars: Scrollbars;
  public static image: HTMLImageElement;

  /** Primary renderer (background, image, grid, etc.) */
  public static primaryRenderingEngine: PrimaryEditorRenderEngine;

  /** Support renderer (old single-engine mode, still compatible) */
  public static supportRenderingEngine: BaseRenderEngine;

  /** Helper for viewport operations */
  public static viewPortHelper: ViewPortHelper;

  /** NEW: store *all* active render engines for each label type */
  public static allSupportRenderingEngines: {
    labelType: LabelType;
    engine: BaseRenderEngine;
  }[] = [];

  /** Optional: keep a Map for easy lookup by LabelType */
  public static renderingEngines: Map<LabelType, BaseRenderEngine> = new Map();

  public static isLoading: boolean = false;
  public static viewPortActionsDisabled: boolean = false;
  public static mousePositionOnViewPortContent: IPoint;
  /** Last known mouse client position — used to keep drawing rubber-bands stuck to the cursor after zoom */
  public static lastMouseClientPosition: IPoint = null;
  public static viewPortSize: ISize;

  // x and y describe the dimension of the margin that remains constant regardless of the scale of the image
  // width and height describes the render image size for 100% scale
  public static defaultRenderImageRect: IRect;
}
